import { render, staticRenderFns } from "./flagged-costs-table.vue?vue&type=template&id=5ef554d6&scoped=true"
import script from "./flagged-costs-table.vue?vue&type=script&lang=ts"
export * from "./flagged-costs-table.vue?vue&type=script&lang=ts"
import style0 from "./flagged-costs-table.vue?vue&type=style&index=0&id=5ef554d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef554d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef554d6')) {
      api.createRecord('5ef554d6', component.options)
    } else {
      api.reload('5ef554d6', component.options)
    }
    module.hot.accept("./flagged-costs-table.vue?vue&type=template&id=5ef554d6&scoped=true", function () {
      api.rerender('5ef554d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/flagged-costs-table/flagged-costs-table.vue"
export default component.exports